// extracted by mini-css-extract-plugin
export default {"title":"SignUp_title__KZdnX","submitButton":"SignUp_submitButton__hgTXS","footerButtonGroup":"SignUp_footerButtonGroup__GdA-p"};